import api from "app/api";

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  email: string;
  token: string;
  password: string;
  password_confirmation: string;
}

export interface ChangePasswordRequest {
  current_password: string;
  password: string;
  password_confirmation: string;
}

export interface RequestEmailChangeRequest {
  current_password: string;
  new_email: string;
}

export interface VerifyEmailChangeRequest {
  user_id: number;
  token: string;
}

export interface ForgotPasswordResponse {
  message: string;
}

export interface ResetPasswordResponse {
  message: string;
}

export interface ChangePasswordResponse {
  message: string;
}

export interface RequestEmailChangeResponse {
  message: string;
}

export interface VerifyEmailChangeResponse {
  message: string;
}

class AuthService {
  /**
   * Send password reset email
   */
  async forgotPassword(data: ForgotPasswordRequest): Promise<{
    success: boolean;
    data?: ForgotPasswordResponse;
    error?: any;
  }> {
    return await api.post("/auth/forgot-password", data);
  }

  /**
   * Reset password with token
   */
  async resetPassword(data: ResetPasswordRequest): Promise<{
    success: boolean;
    data?: ResetPasswordResponse;
    error?: any;
  }> {
    return await api.post("/auth/reset-password", data);
  }

  /**
   * Change password for authenticated user
   */
  async changePassword(data: ChangePasswordRequest): Promise<{
    success: boolean;
    data?: ChangePasswordResponse;
    error?: any;
  }> {
    return await api.put("/auth/change-password", data);
  }

  /**
   * Request email change for authenticated user
   */
  async requestEmailChange(data: RequestEmailChangeRequest): Promise<{
    success: boolean;
    data?: RequestEmailChangeResponse;
    error?: any;
  }> {
    return await api.post("/auth/request-email-change", data);
  }

  /**
   * Verify email change with token
   */
  async verifyEmailChange(data: VerifyEmailChangeRequest): Promise<{
    success: boolean;
    data?: VerifyEmailChangeResponse;
    error?: any;
  }> {
    return await api.post("/auth/verify-email-change", data);
  }
}

export const authService = new AuthService();
export default authService;
